import { render, staticRenderFns } from "./CompanyRateStatistics.vue?vue&type=template&id=1465a078&"
import script from "./CompanyRateStatistics.vue?vue&type=script&lang=js&"
export * from "./CompanyRateStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports